import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'quote-agreements'
const Actions = crudActions(endpoint)

const create = (ctx, post) => {
  const formData = new FormData()

  Object.keys(post).forEach(field => {
    formData.append(field, post[field])
  })

  return axios.post(`/${endpoint}/`, formData)
}

export default {
  ...Actions,
  create,
}
